import {
  Component,
  OnInit,
  Optional,
  Inject,
  OnDestroy,
  SecurityContext,
} from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { ApiService } from 'src/app/common/services/api.service';
import { MessageService } from 'src/app/common/services/message.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { UtilService } from 'src/app/util/util.service';
import { EventTrackerService } from 'src/app/common/services/event-tracker.service';
import { CurrencyService } from 'src/app/util/currency.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FormaterService } from '../../services/formater.service';
import { CROSS } from 'src/defaultImages.js';
import { DomSanitizer} from '@angular/platform-browser';
import { BillingCountersDataService } from '../../services/billing-counters-data.service';

@Component({
  selector: 'app-update-cash',
  templateUrl: './update-cash.component.html',
  styleUrls: ['./update-cash.component.css'],
})
export class UpdateCashComponent implements OnInit, OnDestroy {
  images = { 
    CROSS: CROSS,
  };
  Currency;
  defaultValue: string = '';
  selectedOption: string;
  header: string;
  reasons = [];
  now = new Date();
  staff_name: string;
  amount: string;
  reason_text: string;
  cashCollectForm: FormGroup;
  btnDisabled: boolean = false;
  translationText;
  subscription = new Subscription();
  cashinReasons = [
    { id: 'customer refund', name: 'Customer Refund' },
    { id: 'sell non-menu items', name: 'Sell Non-Menu Items' },
    { id: 'tip', name: 'Tip' },
  ];
  cashoutReasons = [
    { id: 'customer refund', name: 'Customer Refund' },
    { id: 'cancel order', name: 'Cancel Order' },
    { id: 'paid to staff', name: 'Paid To Staff' },
    { id: 'purchases', name: 'Purchases' },
  ];
  cashFloatReasons = [{ id: 'morning update', name: 'Morning Update' }];
  isLoading: boolean = false;
  billingCounterName: string = '';
  billingCounterInfo: string = '';
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private util: UtilService,
    private _eventTracker: EventTrackerService,
    private curr: CurrencyService,
    private translateService: TranslateService,
    public format: FormaterService,
    private _sanitizer: DomSanitizer,
    private _counterDataService: BillingCountersDataService
  ) {
    this.translateService.use(localStorage.getItem('language') || 'en_US');
    this.Currency = this.curr.getCurrency();
  }
  setType(type) {
    if (type == 'cash-in') {
      this.header = this.translationText.CASH_IN;
      this.reasons = this.cashinReasons;
      this.setSubHeading('CASH_IN_COUNTER');
    } else if (type == 'cash-out') {
      this.header = this.translationText.CASH_OUT;
      this.reasons = this.cashoutReasons;
      this.setSubHeading('CASH_OUT_COUNTER');
    } else if (type == 'cash-float') {
      this.header = this.translationText.CASH_FLOAT;
      this.reasons = this.cashFloatReasons;
    }
  }
  ngOnInit() {
    this.getBillingCounterName();
    this.subscription.add(
      this.translateService.get(['OPEN_CASH_DRAWER']).subscribe((res) => {
        this.translationText = res.OPEN_CASH_DRAWER;
        this.cashinReasons = [
          { id: 'customer refund', name: this.translationText.CUSTOMER_REFUND },
          {
            id: 'sell non-menu items',
            name: this.translationText.SELL_NON_MENU_ITEM,
          },
          { id: 'tip', name: this.translationText.TIP },
        ];
        this.cashoutReasons = [
          { id: 'customer refund', name: this.translationText.CUSTOMER_REFUND },
          { id: 'cancel order', name: this.translationText.CANCEL_ORDER },
          { id: 'paid to staff', name: this.translationText.PAID_TO_SATFF },
          { id: 'purchases', name: this.translationText.PURCHASES },
        ];
        this.setType(this.data.type);
      })
    );
    this.cashCollectForm = this.fb.group({
      staff_name: ['', Validators.required],
      amount: ['', Validators.required],
    });
    this.setRadio(this.reasons && this.reasons[0] ? this.reasons[0].id : null);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  private getBillingCounterName(): void {
    this.subscription.add(
      this._counterDataService
        .getMappedBillingCounterName()
        .subscribe((mappedCounterName) => {
          this.billingCounterName = mappedCounterName;
        })
    );
  }
  cancel_clicked() {
    this.dialogRef.close({ data: 'closed' });
  }
  setRadio(id) {
    this.selectedOption = id;
  }
  changes(e) {
    return e.charCode >= 44 && e.charCode <= 57 && e.charCode !== 47;
  }
  save_clicked() {
    this.cashCollectForm.markAllAsTouched();
    if (this.cashCollectForm.valid) {
      this.btnDisabled = true;
      this.isLoading = true;
      const form = this.cashCollectForm.value;
      const payload = {
        restaurant_id: this.data.restaurant_id,
        type: this.data.type,
        staff_name: form.staff_name,
        amount: +this.format.formatMy(form.amount),
        device_id: this.util.getDeviceUID()
      };
      if (this.selectedOption == 'custom') {
        if (
          !(
            this.reason_text == '' ||
            this.reason_text == null ||
            this.reason_text == undefined
          )
        )
          payload['reason'] = this.reason_text;
        else {
          this.messageService.info(
            this.translationText.ENTER_A_REASON_FOR + ` ${this.header} !`
          );
          this.btnDisabled = false;
          this.isLoading = false;
          return;
        }
      } else payload['reason'] = this.selectedOption;
      this.apiService.addCashDetails(payload).subscribe(
        (response) => {
          this.isLoading = false;

          if (response.statusCode == 201) {
            // Send data to React
            if (this.util.cashRegistryEnabled()) {
              const isMultiCashDrawerEnabled = this.util.isMultiCashDrawerEnabled();
              const deviceId = this.util.getDeviceUID();
              const data = {
                restaurant_id: this.data.restaurant_id,
                txn_id: response.data.txn_id,
                action: this.data.type,
                ...(isMultiCashDrawerEnabled && { device_id: deviceId }),
              };
              this.util.send_data_to_react(data, this.data.type);
              this.util.openCashDrawer();
              this.util.openCashDrawerPrintReceipt(
                {
                  restaurant_id: this.data.restaurant_id,
                  txn_id: response.data.txn_id,
                },
                this.data.type
              );
            }
            this.messageService.showSuccess(response.data.message);
            this.dialogRef.close({ data: 'success' });
            this.btnDisabled = false;
          }
        },
        (error) => {
          this.isLoading = false;
          this.messageService.showError(error.error.message);
          this.dialogRef.close({ data: 'closed' });
          this.btnDisabled = false;
        }
      );

      let eventName = '';
      this.data.type === 'cash-in'
        ? (eventName = 'CASH_IN_DONE')
        : (eventName = 'CASH_OUT_DONE');
      this._eventTracker.easyeat_track_event(eventName, {
        'STAFF NAME': form.staff_name,
        AMOUNT: +this.format.formatMy(form.amount),
        REASON:
          this.selectedOption === 'custom'
            ? this.reason_text
            : this.selectedOption,
      });
    } else
      this.messageService.showError(
        this.translationText.FILL_IN_REQUIRED_FIELDS
      );
  }
  private setSubHeading(transalationString: string): void {
    const counterSubHeading = this.translationText[transalationString]?.replace(
      '{{billingCounterName}}',
      this.billingCounterName
    );
    this.sanitizeHtml(counterSubHeading);
  }
  private sanitizeHtml(html: string): void {
    this.billingCounterInfo = this._sanitizer.sanitize(
      SecurityContext.HTML,
      html
    );
  }
}
